import React, { useEffect } from 'react';

import { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useViewport } from 'components/general/useViewPort'
import { useSelector, useDispatch } from 'react-redux'
import { addLegend, removeAllLegends } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import { store } from 'state-management/store'
import { fetchData } from 'data/Querys';
import NotAvailable from 'components/common/NotAvailable';
import Loader from 'components/general/Loader';
import { useQuery } from 'react-query'
import { getDisciplines } from 'data/Querys';
import { Alert } from 'react-bootstrap';

import { useParametersToUrlFriendly } from 'helpers/urlFriendly';

function useIsFound(data) {
    const globalProps = useSelector(getGlobalProps)
    const legends = globalProps.legends
    let resp = false
    Array.isArray(legends) && legends.some(element => {
        if (element.id === data) {
            resp = true;
        }
    });

    return resp;
}
/*
export function useLegend({ data }) {
    const { t, i18n } = useTranslation("translations");
    //const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    //let legend = globalProps.legends

    const { breakPoint } = useViewport();
    let val = t([data + '.xs', data + '.sm', data + '.md', data + '.lg', data + '.default'])

    let sw = true;
    if (breakPoint !== "lg") {
        sw = false
    }

    if (!useIsFound(data)) {
         sw && dispatch(addLegend({ id: { data }, name: { val } }))
    }



    //traduce la primera que encuentra en este orden
}
*/


export function useResetLegend() {
    const dispatch = useDispatch();
    useEffect(() => {
        console.log("Delete")
        //dispatch(removeAllLegends)

    }, []);


}



function getBreakPoints(data, competition, sport, breakPoint) {
    //CTO-DEPORTE-SIZE
    //CTO--SIZE
    //DEPORTE-SIZE
    //SIZE= xs,sm,md,lg,xl,xxl,default

    const mediaQueries = ["xs", "sm", "md", "lg", "xl", "xxl", "default"];
    const index = mediaQueries.indexOf(breakPoint);
    const mediaQueriesFilter = mediaQueries.slice(index, 7);
    let compose = mediaQueriesFilter.map(media => data + "." + media)
    return (
        //        [data + "." + breakPoint, data + '.default']
        compose
    )

}

export function Label({ data, isAddLegend }) {
    const { t } = useTranslation(['labels']);
    const dispatch = useDispatch();
    const { breakPoint } = useViewport();
    //const { mirs_competition, mirs_discipline } = useParametersToUrlFriendly();
    ////const { t } = useTranslation(['translationsMD', 'translationsSM', `translations_${sport}`, `translationsSM_${sport}`, `translations_${competition}`, `translations_SM${competition}`, `translations_${competition}_${sport}`, `translationsSM_${competition}_${sport}`]);
    //let val = t([data + '.xs', data + '.sm', data + '.md', data + '.lg', data + '.default'])
    // let breaksPointsList = getBreakPoints(data, mirs_competition, mirs_discipline, breakPoint)

    let breaksPointsList = getBreakPoints(data, "", "", breakPoint)
    //let val = t([data + "." + breakPoint, data + '.default'])
    let val = t(breaksPointsList)
    useEffect(() => {
        breakPoint !== "lg" && isAddLegend && dispatch(addLegend({ id: data, name: val }))
    });

    // dispatch(addLegend({ id: { data }, name: { val } }))
    //traduce la primera que encuentra en este orden
    return (<label  >{val}</label>);
}

const Navbar = ({ setPage }) => {

    const dispatch = useDispatch();

    const deleteArray = () => {

        dispatch(removeAllLegends)
    }

    return (
        <nav>
            <button onClick={() => setPage('StartList')}>Start List</button>
            <button onClick={() => (setPage('Result'))}>Result</button>
            <button onClick={() => (deleteArray())}>Remove</button>

        </nav>
    );
}



export const About = () => {

    {/*get from translations after from common*/ }
    //const [legend, setLegend] = useState([]);
    //let legend = [];
    const [page, setPage] = useState('StartList');
    const { breakPoint } = useViewport();
    const [dataObj, setDataObj] = useState();
    const [dataObj1, setDataObj1] = useState();
    const [dataObj2, setDataObj2] = useState();

    const { isError: isErrorDisciplines, isLoading: isLoadingDisciplines, data: dataDisciplines } = useQuery(
        {
            queryKey: ['CC_Disciplines', "OG2024", "ENG"],
            queryFn: getDisciplines,

        });


    const [input, setInput] = useState({ nombre: 'Name', apellidos: 'Surname' });


    const getFile = async (url) => {
        //return await fetchData(url);
        const data = await fetchData(url, false);

        //setData(data);
        return data
    }






    if (isErrorDisciplines) { return <NotAvailable />; }
    if (isLoadingDisciplines) { return <Loader />; }



    let url = '/locales/eng/common.json';
    !dataObj && getFile(url).then(function (data) {

        let obj = {}
        for (const [key, value] of Object.entries(data)) {
            obj[key] = {
                "default": value,
            }
        }
        //console.log(obj)
        setDataObj(obj)
    });






    if (dataObj && !dataObj1) {
        let obj = dataObj;
        dataDisciplines?.disciplines?.forEach(item => {
            console.log(item.code)
            url = '/locales/eng/translations_' + item.code + '.json';
            getFile(url).then(function (data1) {
                if (data1) {
                    for (const [key, value] of Object.entries(data1)) {
                        if (!obj[key]) {
                            obj[key] = {}
                        }
                        obj[key][item.code] = {}
                        obj[key][item.code]["default"] = value
                    }
                }
                setDataObj1(obj)
            });
        })
    }


    if (dataObj1 && !dataObj2) {
        let obj = dataObj1;
        dataDisciplines?.disciplines?.forEach(item => {
            url = '/locales/eng/translationsSM_' + item.code + '.json';
            getFile(url).then(function (data2) {
                if (data2) {
                    for (const [key, value] of Object.entries(data2)) {
                        if (!obj[key]) {
                            obj[key] = {}
                        }
                        if (!obj[key][item.code]) {
                            obj[key][item.code] = {}
                        }
                        obj[key][item.code]["sm"] = value
                    }
                }
                setDataObj2(obj)
            });
        })
    }








    return (
        <>

            <RemoveArray2 />
            <Navbar setPage={setPage} />

            <h2>{page}</h2>
            <div>Test Legeds <h1>{breakPoint}</h1></div>
            <hr></hr>

            {page === 'StartList' && <div><Label data={"koko"} isAddLegend={true} /></div>}
            <div><Label data={"header"} isAddLegend={true} /></div>
            <div><Label data={"adidas"} /></div>

            <hr></hr>





            <div>legends</div>
            <DrawArray />



        </>
    );
}



export function GetStore() {
    return JSON.stringify(store.getState().appGlobal.legends)
}



export const Component = ({ valor }) => {
    let { nombre, apellidos } = valor;
    apellidos = "Surname";
    console.log("REDRAW COMPONENT ")
    return (
        <>
            <div>{nombre}</div>
            <div>{apellidos}</div>
        </>
    );
}

export const DrawArray = () => {
    console.log("Draw Array")
    const globalProps = useSelector(getGlobalProps)
    let legend = globalProps.legends

    return (
        <>
            <ul>
                {legend && legend.data.map((item, index) => (
                    <li key={index}> {item.id}-{item.name}</li>
                ))}
            </ul>


        </>
    );
}


export const DrawArray1 = () => {
    console.log("Draw Array")

    let legend = store.getState().appGlobal.legends

    return (
        <>
            <ul>
                {legend && legend.data.map((item, index) => (
                    <li key={index}> {item.id}-{item.name}</li>
                ))}
            </ul>


        </>
    );
}




export const RemoveArray = () => {
    console.log("Try Delete")
    const { breakPoint } = useViewport();
    const dispatch = useDispatch();
    useEffect(() => {
        console.log("Delete")
        dispatch(removeAllLegends)

    }, [breakPoint]);
}

export const RemoveArray2 = () => {


    const dispatch = useDispatch();


    useEffect(() => {
        console.log("Delete")
        dispatch(removeAllLegends)

    });


}


